import * as React from 'react';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import Event from './Event';
import getAccessRoleAndCalendarName from '../../../utils/getAccessRoleAndCalendarName';
import { getEventTime } from '../../../utils/momentUtils';
import getEventClassName from '../../../utils/getEventClassName';
import WeeklyContext from '../../../context/weeklyContext';
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
import getTitleToDisplay from '../../../utils/getTitleToDisplay';
import { DEMO_CALENDARS_IDS } from '../../../constants';
var WeeklyEvent = function (_a) {
    var event = _a.event, isMobile = _a.isMobile;
    var t = useTranslation()[0];
    var extendedProps = event.extendedProps, title = event.title, start = event.start, end = event.end;
    var isPrivate = extendedProps.isPrivate, calendarId = extendedProps.calendarId;
    var _b = React.useContext(
    //@ts-ignore
    isMobile ? WeeklyContextMobile : WeeklyContext), calendarsList = _b.calendarsList, privetEventsTitle = _b.privetEventsTitle;
    var _c = getAccessRoleAndCalendarName(calendarsList, calendarId), accessRole = _c.accessRole, calendarName = _c.calendarName;
    var momentStartTime = moment(start);
    var momentEndTime = moment().add(1, 'day'); // temp date - by default moreOneHourEvent
    if (end) {
        momentEndTime = moment(end);
    }
    var eventDuration = momentEndTime.diff(momentStartTime, 'minutes');
    var titleToDisplay = getTitleToDisplay(t, title, privetEventsTitle, accessRole, isPrivate);
    if (DEMO_CALENDARS_IDS.includes(calendarId)) {
        titleToDisplay = t(title);
    }
    var eventTime = getEventTime(event);
    var ariaLabel = event.allDay
        ? t('Google_Calendar_Event_AllDay', {
            eventName: event.title,
            eventTime: eventTime,
            calendarName: calendarName,
        })
        : t('Google_Calendar_Event', {
            eventName: event.title,
            eventTime: eventTime,
            calendarName: calendarName,
        });
    return (React.createElement(React.Fragment, null,
        React.createElement(Event, { isMobile: isMobile, event: event, titleToDisplay: titleToDisplay, ariaLabel: ariaLabel, className: getEventClassName(eventDuration) })));
};
export default WeeklyEvent;
//# sourceMappingURL=WeeklyEvent.js.map